export const maintenanceI18nSegment = (): string => 'maintenance';
